<template>
  <div class="emp-img-table">
    <img class="emp-img cursor-pointer" :src="imageSrc" height="40" @click="showModal = true">

    <transition name="modal">
      <div v-if="showModal" class="modal-mask" >
        <div class="modal-wrapper"  >
          <div class="modal-container">

            <div class="modal-header">
              <slot name="header">
                <i class="fa fa-close close" @click.prevent="closeModal()" ></i>
                <h4 class="modal-title">Image Gallery</h4>
              </slot>
            </div>

            <div class="modal-body">
              <slot name="body">
              	<img :src="imageSrc"  >
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'image-gallery',
  data () {
    return {
      showModal: false
    }
  },
  methods: {
    closeModal () {
      this.showModal = false
    }
  },
  props: {
    imageSrc: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
.emp-img-table {
  img {
      display: block;
      margin: auto;
      height: 500px;
  }
}
</style>




// WEBPACK FOOTER //
// imageGallery.vue?0f575a36